import React from 'react';

export default function Logo() {
  return (
      <div className="logo">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">BrooksDuBois</span>.com
      </div>
  );
}
